import useCustomerStoryListingStore from 'layout/Listing/variants/customerStories/store';

const useFilterCustomerStory = (allCustomerStory: { data: CustomerStoryResource }[]) => {
  const search = useCustomerStoryListingStore(state => state.search);

  if (!search) {
    return allCustomerStory;
  }

  const searchedCustomerStories = allCustomerStory.filter(story =>
    story?.data?.title?.toLowerCase().includes(search.toLowerCase()),
  );

  return searchedCustomerStories;
};

export default useFilterCustomerStory;
